import { captureMessage } from '@sentry/react';

export interface TimeseriesIDMMigratorContextInterface {
  captureMessage: typeof captureMessage;
}

export const timeseriesIDMMigratorContext: TimeseriesIDMMigratorContextInterface =
  {
    captureMessage,
  };
